import { StdResponse, request } from "@/global/config/request";
import { Component } from "@/global/interface/archi/component";
import localStore from "@/global/store/local-store";

export function findComponentByType(type: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/components/${type}`, {
        params: {
            ...params,
        }
    })
}
// 查找含有name字段的组件
export function findComponentList(params?: {}): Promise<StdResponse<any>> {
    return request.get(`/components`, {
        params: {
            ...params,
        }
    })
}

// 查找含有name字段的组件
export function addComponent(data: Component, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/components`, data, {
        params: {
            ...params,
            projectId: localStore.projectId,
        }
    })
}